import { useTranslation } from 'react-i18next'
import { Link, useNavigate } from '@tanstack/react-router'
import { Button } from 'ui/button'

import { LanguageSelect } from '~/boundedContext/settings/components/language-select'
import { PushNotificationsToggler } from '~/boundedContext/settings/components/push-notifications-toggler'
import { LinkButton } from '~/components/link-button'
import { LS_JWT_KEY } from '~/const/api'
import { MobileBottomLayout } from '~/layout/mobile-bottom'
import { useAccountStore } from '~/stores/account'
import { useCardsGameStore } from '~/stores/cards-game'
import { useSettingsStore } from '~/stores/settings'
import { getJwtToken } from '~/utils/get-jwt-token'
import { clearLastVisitedRoute } from '~/utils/last-visited-route'
import { clearPushSubscriptionForCurrentSession } from '~/utils/push-subscription-session'

import { PasswordlessRegister } from '../../webauthn/components/passwordless-register'
import { BeforeInstallPromptButton } from '../components/before-install-prompt-button'
import { DarkModeToggler } from '../components/dark-mode-toggler'
import { IOSInstallButton } from '../components/ios-install-button'

export const Settings = () => {
  const navigate = useNavigate()
  const { t } = useTranslation()
  const clearAccount = useAccountStore(state => state.clearAccount)
  const clearSessionSettings = useSettingsStore(state => state.clearSessionSettings)
  const resetGameState = useCardsGameStore(state => state.reset)

  return (
    <MobileBottomLayout className="overflow-auto pt-3 sm-landscape:pt-3 md:pt-4">
      <LinkButton to="/settings/languages">{t('Cards languages')}</LinkButton>
      <LinkButton to="/settings/contact-us">{t('Contact us')}</LinkButton>
      <LinkButton to="/settings/subscription/usage">{t('Subscription & usage')}</LinkButton>
      <LinkButton to="/settings/snooze">{t('Snooze settings')}</LinkButton>
      <PasswordlessRegister />
      <BeforeInstallPromptButton />
      <IOSInstallButton />
      {getJwtToken() && (
        <Button
          onClick={() => {
            void clearPushSubscriptionForCurrentSession()
            localStorage.removeItem(LS_JWT_KEY)
            clearLastVisitedRoute()
            resetGameState()
            clearAccount()
            clearSessionSettings()
            void navigate({ to: '/auth/login' })
          }}
          variant="secondary"
        >
          {t('Logout')}
        </Button>
      )}
      <div className="flex w-full flex-col items-center justify-between gap-3 md:gap-4">
        <div className="flex w-full items-center">
          <DarkModeToggler />
          <div className="ml-auto">
            <LanguageSelect />
          </div>
        </div>
        <div className="flex w-full items-center gap-2">
          <PushNotificationsToggler />
          <Link
            className="ml-auto min-w-0 max-w-[60%] hyphens-auto whitespace-normal break-words text-center text-sm underline opacity-80 md:text-base"
            to="/privacy-policy"
          >
            {t('Privacy Policy')}
          </Link>
        </div>
      </div>
    </MobileBottomLayout>
  )
}
